import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

export const INVOICE_PERIODS_QUERY = gql(`
  query InvoicePeriods($clientId: String!) {
    invoicePeriods(clientId: $clientId) {
      year
      month
      numberOfRecords
      invoiceId
      createdAt
      totalCostInCents
    }
  }  
`);

export function useInvoicePeriods() {
    const { client } = useRequireCurrentClient();

    const { data, loading, error } = useQuery(INVOICE_PERIODS_QUERY, {
        variables: {
            clientId: client.id,
        },
    });

    return { loading, error, data: data?.invoicePeriods };
}
